import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import brandData from '../../data/brandData.json';

const CTA = () => {
  const { cta } = brandData

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section className='py-5 overflow-hidden' id='contact-brand'>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <motion.div variants={cardVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}
              whileHover={{ scale: 1.01, transition: { duration: 0.3 } }}
            >
              <Card className="border-0 shadow rounded-4">
                <Card.Body className="p-4 p-md-5 text-center">
                  <motion.div initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
                    <Badge bg="success-subtle" text="success" className="mb-2">
                      {cta.badge}
                    </Badge>
                  </motion.div>
                  <motion.h2 className="mb-2" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
                    {cta.title}
                  </motion.h2>
                  <motion.p className="text-secondary mb-4" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
                    {cta.description}
                  </motion.p>
                  <motion.div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.5 }}>
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button variant="success"  className="px-4" href="mailto:info@boowebsite.com">Book a Call</Button>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button variant="outline-secondary"  className="px-4" href="#brand-work">See Work</Button>
                    </motion.div>
                  </motion.div>
                  <motion.div className="mt-3 small text-secondary" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.6 }}>
                    {cta.note}
                  </motion.div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default CTA;
